import { TreeNode, OriginalItem } from "../types/types";

/**
 * Maps the tree data to the required format.
 * @param data - The data to be mapped.
 * @returns The mapped tree data.
 */
export const mapTreeData = (data: OriginalItem[]): TreeNode[] => {
  return data.map((item) => {
    const { guid, name, children, sortOrder, ...rest } = item;
    return {
      title: name,
      key: guid,
      children: children ? mapTreeData(children) : [],
      sortOrder,
      data: item,
      ...rest,
    };
  });
};

/**
 * Finds a node in the tree by its key.
 * @param nodes - The tree nodes.
 * @param key - The key of the node to find.
 * @returns The found node or undefined if not found.
 */
export const findNode = (nodes: TreeNode[], key: string): TreeNode | undefined => {
  for (const node of nodes) {
    if (node.key === key) return node;
    if (node.children) {
      const found = findNode(node.children, key);
      if (found) return found;
    }
  }
  return undefined;
};

/**
 * Gathers all keys of a node and its children with their levels.
 * @param node - The node to gather keys from.
 * @param level - The current level of the node.
 * @returns The keys with their levels.
 */
export const gatherKeysWithLevel = (
  node: TreeNode,
  level: number = 0
): { key: string; level: number; parentKey: string | undefined }[] => {
  const parentKey = node.parentPageGuid ?? node.data?.parentPageGuid ?? undefined;

  let keys: { key: string; level: number; parentKey: string | undefined }[] = [
    { key: node.key, level, parentKey }
  ];

  if (node.children) {
    node.children.forEach((child) => {
      keys = keys.concat(gatherKeysWithLevel(child, level + 1));
    });
  }
  return keys;
};